import Colors from "../../theme/Colours";

export const headerStyle = {
  display: "flex",
  alignItems: "center",
};

export const headerA = {
  fontFamily: "Poppins",
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "30px",
  color: "#1A1A1A",
};

export const headerB = {
  fontFamily: "Poppins",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "21px",
  color: "#4D4D4D",
};

export const card = {
  borderColor: "#E5E5E5",
  border: "1px",
  borderRadius: "8px",
  backgroundColor: { xs: "transparent", sm: "none" },
  boxShadow: { xs: "none", sm: "0px 2px 4px rgba(230, 230, 230, 0.5)" },
  paddingBottom: { xs: 0, sm: "67px" },
};

export const cardBody = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  padding: { xs: "0px", sm: "24px" },
  justifyContent: "center",
};

export const paymentCard = {
  borderColor: "#E6E6E6",
  border: "1px",
  borderRadius: "8px",
  backgroundColor: Colors.background2,
  marginTop: { xs: "16px", sm: "0px" },
};

export const headerBorderBottom = {
  borderBottom: 1,
  borderColor: "#E5E5E5",
};

export const addressCardContainer = {
  borderColor: "#E6E6E6",
  border: "1px",
  borderRadius: "8px",
  backgroundColor: Colors.background2,
  display: "flex",
  flexDirection: "row",
  width: { xs: "100%", sm: "40%" },
};

export const addressCardHeader = {
  fontFamily: "Poppins",
  fontSize: { xs: "12px", sm: "14px" },
  fontWeight: 500,
  lineHeight: "14px",
  color: "#999999",
  textTransform: "uppercase",
};

export const cardStyle = {
  borderRadius: "6px",
  width: { xs: "100%", md: "90%" },
};

export const addressTextStyle1 = {
  fontFamily: "Poppins",
  fontSize: { xs: "12px", sm: "16px" },
  fontWeight: 400,
  color: "#1A1A1A",
};

export const addressTextStyle2 = {
  fontFamily: "Poppins",
  fontSize: { xs: "10px", sm: "14px" },
  fontWeight: 400,
  color: "#666666",
  pb: { xs: "10px" },
  whiteSpace: "pre-line",
};

export const addressTextStyle3 = {
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: 500,
  color: "#999999",
  textTransform: "uppercase",
};

export const addressTextStyle4 = {
  ...addressTextStyle2,
  color: "#1A1A1A",
  pb: "12px",
};

export const paymentValues = {
  ...addressTextStyle2,
  fontWeight: 500,
  color: "#1A1A1A",
  py: "12px",
};

export const paymentTotal = {
  fontSize: "18px",
  fontWeight: 600,
  color: "#1A1A1A",
  py: "12px",
};

export const selectContainerStyle = {
  width: "305px",
  height: "48px",
  borderRadius: "8px",
  fontSize: "14px",
};

export const dropDownContainer = {
  flexDirection: "row",
  gap: "8px",
  width: "inherit",
  borderRadius: "16px",
  position: "fixed",
};

export const dropdownTitle = {
  marginTop: "40px",
  fontFamily: "Poppins",
  fontSize: " 20px",
  fontWeight: 500,
};

export const menuItemTextStyle = {
  fontFamily: "Inter",
  fontWeight: 400,
  fontSize: "12px",
  fontColor: "#1D1D1D",
  ml: "8px",
};

export const dropDownStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const InputLabelStyle = {
  "&.MuiInputLabel-root": {
    position: "absolute",
    marginLeft: "10px",
    color: "rgba(126, 126, 126, 1)",
  },
};

export const stepperStyles = {
  stepper: {
    borderColor: "#E6E6E6",
    border: "1px",
    borderRadius: "8px",
    backgroundColor: Colors.background2,
    boxShadow: { xs: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)", sm: "none" },
    padding: { xs: "10px 0px", sm: "0px" },
    mt: { xs: "10px", sm: "30px" },
    width: "100%",
    mb: { xs: "0px", sm: "54px" },
  },
  stepperLabel: {
    "& .MuiStepLabel-label": {
      fontSize: { xs: "6px", sm: "14px" },
      marginTop: { xs: "4px", sm: "8px" },
    },
  },
};
